<template>
	<div class="container">
		<!-- FILTROS PRINCIPALES -->
		<b-row class="mb-4">
			<b-container>
				<h3 class="text-center py-2"><b><i>{{ f_titulo() }}</i></b></h3>

				<h5 class="text-center py-2">
					<b-row class="mb-4 justify-content-center align-items-center text-lg">

						<!-- REPORTE - SOLO PARA RECLASIFICACIÓN -->
						<b-col v-if="reclasifica" md="auto" class="text-center px-2">
							<label class="d-block fw-bold mb-1"><b>{{ labels.reporte }}:</b></label>
							<select v-model="dialogReportes" @change="isEmpty = true" class="form-control mx-auto"
								style="font-size: 1.2rem; padding: 0.750rem 1rem; height: auto; width: 240px;">
								<option value="">Seleccione...</option>
								<option v-for="(item, idx) in reportes" :key="'codigo_' + idx" :value="item.codigo">
									{{ item.codigo }}-{{ item.nombre }}
								</option>
							</select>
						</b-col>

						<!-- VIGENCIA -->
						<b-col md="auto" class="text-center px-2">
							<label class="d-block fw-bold mb-1"><b>{{ labels.vigencia }}:</b></label>
							<select v-model="dialogFechas" @change="isEmpty = true" class="form-control mx-auto"
								style="font-size: 1.2rem; padding: 0.750rem 1rem; height: auto; width: 240px;">
								<option value="">Seleccione...</option>
								<option v-for="(item, idx) in fechas" :key="'fecha-' + idx" :value="item.fecha">
									{{ item.fecha }}
								</option>
							</select>
						</b-col>

						<!-- GRUPO -->
						<b-col md="auto" class="text-center px-2">
							<label class="d-block fw-bold mb-1"><b>{{ labels.grupo }}:</b></label>
							<select v-model="grupoId" @change="filtraCompaniasPorGrupo()" class="form-control mx-auto"
								style="font-size: 1.2rem; padding: 0.750rem 1rem; height: auto; width: 240px;">
								<option value="">Seleccione...</option>
								<option value="all">Todos los grupos</option>
								<option v-for="grupo in listGrupos" :key="'grupo-' + grupo.id" :value="grupo.id">
									{{ grupo.nombre }}
								</option>
							</select>
						</b-col>

						<!-- COMPAÑÍA -->
						<b-col md="auto" class="text-center px-2 filtro-col">
							<label class="d-block fw-bold mb-1"><b>{{ labels.compania }}:</b></label>
							<select v-model="dialogCompanias" @change="seleccionaCompania()"
								class="form-control filtro-select mx-auto"
								style="font-size: 1.2rem; padding: 0.750rem 1rem; height: auto; width: 240px;">
								<option value="">Seleccione...</option>
								<option v-for="(item, idx) in companiasFiltradas" :key="'compania-' + idx"
									:value="item.id">
									{{ item.acronym }} {{ item.nombre }}
								</option>
							</select>
						</b-col>
					</b-row>

					<!-- BOTONES DE ACCIÓN -->
					<b-row class="mb-4 justify-content-center align-items-center">
						<b-col md="auto" class="text-center">
							<!-- Condición para el botón Consultar según el caso -->
							<b-button
								v-if="reclasifica ? (dialogFechas && dialogCompanias && dialogReportes) : (dialogFechas && (dialogCompanias || grupoId))"
								variant="primary" @click="consultar()" class="btn-lg px-5 mx-2 fs-5"
								:disabled="isLoading">
								<b><i>{{ labels.consultar }}</i></b>
							</b-button>
							<b-button v-if="fgl_consultar && dialogCompanias" variant="outline-primary" @click="crear"
								:disabled="isVigenciaBloqueada"
								class="btn-lg px-5 mx-2 fs-5">
								<b><i>{{ textoBotonNuevo() }}</i></b>
							</b-button>
						</b-col>
					</b-row>
				</h5>
			</b-container>
		</b-row>

		<!-- SPINNER DE CARGA -->
		<b-row v-if="isLoading">
			<b-container class="text-center py-5">
				<b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
				<h4 class="text-primary mt-3"><b><i>Cargando información...</i></b></h4>
			</b-container>
		</b-row>

		<!-- TABLA PRINCIPAL -->
		<b-container
			v-if="((reclasifica && dialogFechas && dialogCompanias && dialogReportes) || (!reclasifica && dialogFechas && fgl_consultar)) && !isLoading && !showDialogEdit"
			class="pb-3">
			<!-- Mostrar tabla solo cuando HAY datos -->
			<div v-if="!isEmpty && ajustesTopside.length > 0" class="table-responsive">
				<table class="table table-sm table-bordered mb-0">
					<thead>
						<tr class="text-center">
							<th class="py-1 px-2" style="width: 50px;">{{ labels.secuencia }}</th>
							<th v-if="!reclasifica" class="py-1 px-2" style="width: 100px;">Compañía</th>
							<th class="py-1 px-2" style="width: 80px;">{{ labels.cuenta }}</th>
							<th class="py-1 px-2" style="min-width: 180px;">{{ labels.descripcion }}</th>
							<th class="py-1 px-2" style="width: 70px;">{{ labels.niif }}</th>
							<th v-if="reclasifica" class="py-1 px-2" style="width: 70px;">{{ labels.niif1 }}</th>
							<th class="py-1 px-2" style="width: 80px;">{{ labels.funcional1 }}</th>
							<th class="py-1 px-2" style="width: 80px;">{{ labels.promedio1 }}</th>
							<th class="py-1 px-2" style="width: 80px;">{{ labels.interna1 }}</th>
							<th class="py-1 px-2" style="width: 80px;">{{ labels.funcional2 }}</th>
							<th class="py-1 px-2" style="width: 80px;">{{ labels.promedio2 }}</th>
							<th class="py-1 px-2" style="width: 80px;">{{ labels.interna2 }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in ajustesTopside" :key="item.secuencia"
							:class="{ 'clickable-row': true, 'selected-row': selectedRow === item.secuencia }"
							@click="f_muestra(item)">
							<td class="text-center py-1 px-2 font-monospace">{{ item.secuencia }}</td>
							<td v-if="!reclasifica" class="text-left py-1 px-2">{{ item.nombreCompania ||
								obtenerNombreCompania(item.idCompania) }}</td>
							<td class="text-left py-1 px-2 font-monospace">{{ item.cuenta }}</td>
							<td class="text-left py-1 px-2 text-truncate" :title="item.descripcion"
								style="max-width: 180px;">
								{{ item.descripcion }}
							</td>
							<td class="text-left py-1 px-2">{{ reclasifica ? f_niif(item.niif) :
								f_niifCuenta(item.cuenta) }}</td>
							<td v-if="reclasifica" class="text-left py-1 px-2">{{ f_niif(item.niif1) }}</td>
							<td class="text-right py-1 px-2 font-monospace">{{ item.ajuste_funcional1 }}</td>
							<td class="text-right py-1 px-2 font-monospace">{{ item.ajuste_promedio1 }}</td>
							<td class="text-right py-1 px-2 font-monospace">{{ item.ajuste_interna1 }}</td>
							<td class="text-right py-1 px-2 font-monospace">{{ item.ajuste_funcional2 }}</td>
							<td class="text-right py-1 px-2 font-monospace">{{ item.ajuste_promedio2 }}</td>
							<td class="text-right py-1 px-2 font-monospace">{{ item.ajuste_interna2 }}</td>
						</tr>
					</tbody>
				</table>

				<div class="text-center mt-2" v-if="selectedRow">
					<div class="alert alert-info d-inline-block py-2 px-3">
						<strong>Fila seleccionada:</strong> Secuencia {{ selectedRow }}
					</div>
				</div>
			</div>

			<!-- Mostrar mensaje cuando NO hay datos -->
			<div v-else class="text-center py-5">
				<b-row>
					<b-col md="2" class="mx-auto">
						<div class="success-svg mb-4" :class="{ active: isEmpty }">
							<img src="../../assets/imgs/file-2.svg" alt="warning" />
						</div>
					</b-col>
					<b-col md="12" class="justify-content-around">
						<span id="message" v-if="isEmpty">{{ labels.empty }}</span>
					</b-col>
				</b-row>
			</div>
		</b-container>
		<!-- FORMULARIO CREAR TOPSIDE (SIN MODAL) -->
		<b-container v-if="showDialogEdit" class="mt-4 mb-5 p-4 border rounded bg-light">
			<h4 class="text-center mb-4"><b><i>{{ f_titulo() }} - Nuevo Registro</i></b></h4>

			<!-- BÚSQUEDA DE CUENTA -->
			<b-row class="mb-4">
				<b-col cols="12">
					<label class="fw-bold mb-2"><b>Buscar Cuenta:</b></label>
					<b-input-group>
						<b-input-group-prepend is-text><b-icon icon="search"></b-icon></b-input-group-prepend>
						<b-form-input v-model="busquedaCuenta" @input="buscarCuenta"
							placeholder="Ingrese código o descripción de la cuenta..."
							class="form-control-lg"></b-form-input>
						<b-input-group-append>
							<b-button variant="secondary" @click="limpiarBusqueda">Limpiar</b-button>
						</b-input-group-append>
					</b-input-group>

					<!-- SUGERENCIAS -->
					<b-list-group v-if="sugerenciasCuentas.length > 0" class="mt-2"
						style="max-height: 200px; overflow-y: auto;">
						<b-list-group-item v-for="cuenta in sugerenciasCuentas" :key="cuenta.id"
							@click="seleccionarCuenta(cuenta)" class="cursor-pointer hover-bg"
							:active="v_id === cuenta.id">
							<strong>{{ cuenta.cuenta }}</strong> - {{ cuenta.descripcion }}
							<small class="text-muted d-block">NIIF: {{ f_niifCuenta1(cuenta.cuenta) }} - {{
								f_niif(f_niifCuenta1(cuenta.cuenta)) }}</small>
						</b-list-group-item>
					</b-list-group>
				</b-col>
			</b-row>

			<!-- CUENTA SELECCIONADA -->
			<b-row v-if="v_cuenta" class="mb-4 p-3 bg-white border rounded">
				<b-col md="3" class="border-right">
					<small><b>Código:</b></small>
					<h5 class="mb-0 text-primary"><strong>{{ v_cuenta }}</strong></h5>
				</b-col>
				<b-col md="5" class="border-right">
					<small><b>Descripción:</b></small>
					<h5 class="mb-0"><strong>{{ v_descripcion }}</strong></h5>
				</b-col>
				<b-col md="4">
					<small><b>NIIF:</b></small>
					<h5 class="mb-0"><strong>{{ v_niif }} - {{ f_niif(v_niif) }}</strong></h5>
				</b-col>
			</b-row>

			<!-- AJUSTES -->
			<b-row class="mb-1">
				<b-col cols="4" class="border bg-secondary text-white">
					<h6 class="text-center mb-1"><b><i>{{ labels.funcional1 }}</i></b></h6>
				</b-col>
				<b-col cols="4" class="border bg-secondary text-white">
					<h6 class="text-center mb-1"><b><i>{{ labels.promedio1 }}</i></b></h6>
				</b-col>
				<b-col cols="4" class="border bg-secondary text-white">
					<h6 class="text-center mb-1"><b><i>{{ labels.interna1 }}</i></b></h6>
				</b-col>
			</b-row>
			<b-row class="mb-3">
				<b-col cols="4" class="border p-1">
					<b-form-input v-model="v_ajuste_funcional1" type="number" step="0.01"
						class="text-right form-control-lg"></b-form-input>
				</b-col>
				<b-col cols="4" class="border p-1">
					<b-form-input v-model="v_ajuste_promedio1" type="number" step="0.01"
						class="text-right form-control-lg"></b-form-input>
				</b-col>
				<b-col cols="4" class="border p-1">
					<b-form-input v-model="v_ajuste_interna1" type="number" step="0.01"
						class="text-right form-control-lg"></b-form-input>
				</b-col>
			</b-row>

			<b-row class="mb-1">
				<b-col cols="4" class="border bg-secondary text-white">
					<h6 class="text-center mb-1"><b><i>{{ labels.funcional2 }}</i></b></h6>
				</b-col>
				<b-col cols="4" class="border bg-secondary text-white">
					<h6 class="text-center mb-1"><b><i>{{ labels.promedio2 }}</i></b></h6>
				</b-col>
				<b-col cols="4" class="border bg-secondary text-white">
					<h6 class="text-center mb-1"><b><i>{{ labels.interna2 }}</i></b></h6>
				</b-col>
			</b-row>
			<b-row class="mb-3">
				<b-col cols="4" class="border p-1">
					<b-form-input v-model="v_ajuste_funcional2" type="number" step="0.01"
						class="text-right form-control-lg"></b-form-input>
				</b-col>
				<b-col cols="4" class="border p-1">
					<b-form-input v-model="v_ajuste_promedio2" type="number" step="0.01"
						class="text-right form-control-lg"></b-form-input>
				</b-col>
				<b-col cols="4" class="border p-1">
					<b-form-input v-model="v_ajuste_interna2" type="number" step="0.01"
						class="text-right form-control-lg"></b-form-input>
				</b-col>
			</b-row>

			<!-- RECLASIFICACIÓN NIIF -->
			<b-row v-if="reclasifica" class="mb-4">
				<b-col cols="6" class="border bg-light p-2">
					<h6 class="text-center mb-0"><b><i>{{ labels.niif1 }}</i></b></h6>
				</b-col>
				<b-col cols="6" class="border p-1">
					<b-form-select v-model="v_niif1" :options="opcionesNiifSelect"
						class="form-control-lg"></b-form-select>
				</b-col>
			</b-row>

			<!-- TOTALES -->
			<b-row class="mb-4 p-3 bg-info text-white rounded">
				<b-col md="4">
					<p class="mb-0"><b>Total Funcional:</b> {{ formatoNumero(totalFuncional) }}</p>
				</b-col>
				<b-col md="4">
					<p class="mb-0"><b>Total Promedio:</b> {{ formatoNumero(totalPromedio) }}</p>
				</b-col>
				<b-col md="4">
					<p class="mb-0"><b>Total Interna:</b> {{ formatoNumero(totalInterna) }}</p>
				</b-col>
			</b-row>

			<!-- BOTONES -->
			<b-row class="mt-3">
				<b-col cols="12" class="text-center">
					<b-button variant="primary" @click="grabeAjusteTopside()" :disabled="!v_cuenta || isVigenciaBloqueada"
						class="px-4 mx-2 btn-lg">
						<b-icon icon="check-circle"></b-icon> Guardar
					</b-button>
					<b-button variant="outline-secondary" @click="showDialogEdit = false" class="px-4 mx-2 btn-lg">
						<b-icon icon="x-circle"></b-icon> Cancelar
					</b-button>
				</b-col>
			</b-row>
		</b-container>

		<!-- MODAL DETALLE -->
		<md-dialog :md-active.sync="showDialogTopside">
			<md-dialog-title class="text-center"><b><i>{{ f_titulo() }}</i></b></md-dialog-title>
			<md-dialog-content>
				<b-row class="border-bottom">
					<b-col cols="3">
						<h5><b><i>{{ labels.cuenta }}</i></b></h5>
					</b-col>
					<b-col cols="3">
						<h5>{{ formTopside.cuenta }}</h5>
					</b-col>
					<b-col cols="6">
						<h5>{{ formTopside.descripcion }}</h5>
					</b-col>
				</b-row>

				<b-row class="mt-2">
					<b-col cols="4" class="border">
						<h5><b><i>{{ labels.funcional1 }}</i></b></h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5><b><i>{{ labels.promedio1 }}</i></b></h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5><b><i>{{ labels.interna1 }}</i></b></h5>
					</b-col>
				</b-row>
				<b-row class="mb-2">
					<b-col cols="4" class="border">
						<h5>{{ formTopside.ajuste_funcional1 }}</h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5>{{ formTopside.ajuste_promedio1 }}</h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5>{{ formTopside.ajuste_interna1 }}</h5>
					</b-col>
				</b-row>

				<b-row>
					<b-col cols="4" class="border">
						<h5><b><i>{{ labels.funcional2 }}</i></b></h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5><b><i>{{ labels.promedio2 }}</i></b></h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5><b><i>{{ labels.interna2 }}</i></b></h5>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="4" class="border">
						<h5>{{ formTopside.ajuste_funcional2 }}</h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5>{{ formTopside.ajuste_promedio2 }}</h5>
					</b-col>
					<b-col cols="4" class="border">
						<h5>{{ formTopside.ajuste_interna2 }}</h5>
					</b-col>
				</b-row>

				<md-dialog-actions>
					<md-button class="md-primary md-raised"
						@click="borraAjusteTopside(formTopside.secuencia)" :disabled="isVigenciaBloqueada">Borrar</md-button>
					<md-button class="md-accent md-raised" @click="showDialogTopside = false">Cerrar</md-button>
				</md-dialog-actions>
			</md-dialog-content>
		</md-dialog>
	</div>
</template>

<script>
import Balance from "@/services/BalanceNiif"
import PlanConsolidacion from "@/services/PlanConsolidacion"
import Grupo from "@/services/Grupo"
import AjustesConsol from "@/services/AjustesConsol"

const ordenefechas = (arreglo = undefined) => [...arreglo].sort((a, b) => a - b)

export default {
	name: "BalanceNiif",
	data: () => ({
		showDialogEdit: false,
		showDialogTopside: false,
		ajustesTopside: [],
		isLoading: false,
		error: false,
		formEdit: {
			cuenta: "", descripcion: '', niif: '', niif_desc: '', saldo_actual: 0,
			funcional1: 0, promedio1: 0, interna1: 0, funcional2: 0, promedio2: 0, interna2: 0,
			ajuste_actual: 0, ajuste_funcional1: '', ajuste_promedio1: '', ajuste_interna1: '',
			ajuste_funcional2: '', ajuste_promedio2: '', ajuste_interna2: '', niif1: '',
			porcentaje: 1, u_crea: 1, tipo_ajuste: 0, codReporte: ''
		},
		formTopside: {},
		reclasifica: false,
		idCompania: 1,
		vigencia: '',
		companias: [],
		companiasFiltradas: [],
		companiaUsuario: [],
		dialogCompanias: '',
		fechas: [],
		dialogFechas: '',
		codigoReportePrincipal: null,
		reportes: [],
		dialogReportes: '',
		fgl_consultar: false,
		cuentas: [],
		niif: [],
		niifCuentas: [],
		moneda: 0,
		v_cuenta: '',
		v_id: null,
		v_niif: '',
		v_niif1: null,
		v_descripcion: '',
		v_ajuste_funcional1: 0,
		v_ajuste_promedio1: 0,
		v_ajuste_interna1: 0,
		v_ajuste_funcional2: 0,
		v_ajuste_promedio2: 0,
		v_ajuste_interna2: 0,
		vt_ajuste_funcional1: 0,
		vt_ajuste_promedio1: 0,
		vt_ajuste_interna1: 0,
		vt_ajuste_funcional2: 0,
		vt_ajuste_promedio2: 0,
		vt_ajuste_interna2: 0,
		busquedaCuenta: '',
		sugerenciasCuentas: [],
		listGrupos: [],
		grupoId: '',
		selectedRow: null,
		isEmpty: true,
	}),
	computed: {
		isVigenciaBloqueada() {
			return this.dialogFechas ? !this.$store.getters.isPeriodoEnabled(this.dialogFechas) : false
		},
		labels() {
			const es = {
				title: "BALANCE",
				secuencia: "SEQ", cuenta: "Cuenta", descripcion: "Descripcion",
				niif: "Niif", niif1: "Reclasificacion",
				saldo_periodo_anterior: "Saldo Periodo Anterior", saldo_actual: "Saldo",
				funcional1: "Funcional", ajuste_actual: "Ajuste Moneda",
				ajuste_funcional1: "Ajuste Funcional", promedio1: "Promedio",
				interna1: "Interna", funcional2: "Funcional2", promedio2: "Promedio2",
				interna2: "Interna2", saldo_periodo_actual: "Saldo A",
				consultar: "Consultar",
				reporte: "Reporte",
				vigencia: "Vigencia",
				grupo: "Grupo",
				compania: "Compañía",
				empty: "No hay datos disponibles"
			}
			const en = {
				title: "NIIF CHECKING BALANCE",
				secuencia: "SEQ", cuenta: "Account", descripcion: "Description",
				niif: "NIIF", niif1: "Reclassification",
				funcional1: "Currency Funcional", promedio1: "Average",
				interna1: "Internal", funcional2: "Alternative", promedio2: "Average",
				interna2: "Internal", saldo_actual: "Currency Balance",
				saldo_periodo_anterior: "Previous Period Balance",
				saldo_periodo_actual: "Current Period Balance",
				consultar: "Consult",
				reporte: "Report",
				vigencia: "Validity",
				grupo: "Group",
				compania: "Company" ,
				empty: "No hay datos disponibles"
			}
			return this.$store.state._language == "es-ES" ? es : en
		}, 
		mapaNiifCuenta() {
			const mapa = {}
			this.niifCuentas?.forEach(c => mapa[c.cuenta] = c.niif)
			return mapa
		},

		mapaNiif() {
			const mapa = {}
			this.niif?.forEach(n => mapa[n.niif] = n.nameNiif)
			return mapa
		},

		totalFuncional() { return parseFloat(this.v_ajuste_funcional1 || 0) + parseFloat(this.v_ajuste_funcional2 || 0) },
		totalPromedio() { return parseFloat(this.v_ajuste_promedio1 || 0) + parseFloat(this.v_ajuste_promedio2 || 0) },
		totalInterna() { return parseFloat(this.v_ajuste_interna1 || 0) + parseFloat(this.v_ajuste_interna2 || 0) },
		opcionesNiifSelect() {
			return this.niif.map(n => ({ value: n.niif, text: `${n.niif} - ${n.nameNiif}` }))
		}
	},
	methods: {
		filtraCompaniasPorGrupo() {
			this.isEmpty = true
			this.dialogCompanias = null
			if (this.grupoId === "all") {
				this.companiasFiltradas = [...this.companias]
			} else if (this.grupoId) {
				const grupoIdStr = this.grupoId.toString()
				this.companiasFiltradas = this.companias.filter(compania => {
					if (!compania.id_grupos) return false
					const gruposCompania = compania.id_grupos.split(',').map(id => id.trim())
					return gruposCompania.includes(grupoIdStr)
				})
			} else {
				this.companiasFiltradas = [...this.companias]
			}
		},
		buscarCuenta() {
			const texto = this.busquedaCuenta.trim().toLowerCase()
			if (texto.length > 0) {
				this.sugerenciasCuentas = this.cuentas.filter(cuenta => 
					cuenta.cuenta.toLowerCase().includes(texto) || 
					cuenta.descripcion.toLowerCase().includes(texto)
				).slice(0, 10) // Limitar a 10 sugerencias
			} else {
				this.sugerenciasCuentas = []
			}
		},
		textoBotonNuevo() {
			return this.$route.name == "ajustesTopside" ? "Nuevo Topside" : "Nueva Reclasificación";
		},
		limpiarBusqueda() {
			this.busquedaCuenta = ''
			this.sugerenciasCuentas = []
		},
		seleccionarCuenta(cuenta) {
			this.v_id = cuenta.id
			this.f_datos_cuenta(cuenta.id)
			this.busquedaCuenta = ''
			this.sugerenciasCuentas = []
		},
		seleccionaCompania() {
			this.isEmpty = true
			setTimeout(() => {
				let buscaMoneda = this.companias.filter((item) => item.id == this.dialogCompanias)
				this.moneda = buscaMoneda[0].acronimo
			}, 500)
		},
		f_datos_cuenta(p_id) {
			const cuenta = this.cuentas.find((cuenta) => cuenta.id === p_id)
			if (cuenta) {
				this.v_descripcion = cuenta.descripcion
				this.v_cuenta = cuenta.cuenta
				this.v_niif = this.f_niifCuenta1(cuenta.cuenta)
			}
		},
		obtenerNombreCompania(idCompania) {
			const compania = this.companias.find(c => c.id == idCompania)
			return compania ? compania.nombre : ''
		},
		consultar() {
			this.fgl_consultar = false;
			this.isLoading = true;

			if (!this.dialogFechas) {
				this.$toast.warning("Seleccione una vigencia");
				this.isLoading = false;
				return;
			}

			const v_tipo_ajuste = this.$route.name == "ajustesTopside" ? 0 : 1;

			// CASO RECLASIFICACIÓN (requiere compañía y reporte específico)
			if (this.reclasifica) {
				if (!this.dialogCompanias || !this.dialogReportes) {
					this.$toast.warning("Seleccione compañía y reporte");
					this.isLoading = false;
					return;
				}

				this.idCompania = this.dialogCompanias;
				this.vigencia = this.dialogFechas;

				Promise.all([
					PlanConsolidacion.getPlanConsPorCompVige(this.dialogFechas, this.dialogReportes),
					PlanConsolidacion.getPlanConsPorCuentaVige(this.dialogCompanias, this.dialogFechas, this.dialogReportes),
					Balance.getAjustesTopside(this.idCompania, this.vigencia, this.dialogReportes, v_tipo_ajuste)
				]).then(([niifResult, cuentasResult, ajustesResult]) => {
					this.niif = niifResult.data.planConsNiif;
					this.niifCuentas = cuentasResult.data.planConsCuentas;
					this.ajustesTopside = (ajustesResult.data.ajustesTopside || []).sort((a, b) => a.secuencia - b.secuencia);
					this.f_calculeTopside();
					this.fgl_consultar = true;
					this.isLoading = false;
					this.isEmpty = this.ajustesTopside.length === 0;
				}).catch((error) => {
					console.error(error);
					this.error = true;
					this.isLoading = false;
					this.$toast.error("Error al consultar reclasificaciones");
				});
			}
			// CASO TOPSIDE (puede ser por compañía o por grupo)
			else {
				if (!this.dialogCompanias && !this.grupoId) {
					this.$toast.warning("Seleccione una compañía o un grupo");
					this.isLoading = false;
					return;
				}

				// Si hay compañía seleccionada
				if (this.dialogCompanias) {
					this.idCompania = this.dialogCompanias;
					this.vigencia = this.dialogFechas;

					Promise.all([
						PlanConsolidacion.getPlanConsPorCompVige(this.dialogFechas, this.codigoReportePrincipal),
						PlanConsolidacion.getPlanConsPorCuentaVige(this.dialogCompanias, this.dialogFechas, this.codigoReportePrincipal),
						Balance.getAjustesTopside(this.idCompania, this.vigencia, this.codigoReportePrincipal, v_tipo_ajuste)
					]).then(([niifResult, cuentasResult, ajustesResult]) => {
						this.niif = niifResult.data.planConsNiif;
						this.niifCuentas = cuentasResult.data.planConsCuentas;
						const nombreCompania = this.companias.find(c => c.id == this.dialogCompanias)?.nombre || '';
						this.ajustesTopside = (ajustesResult.data.ajustesTopside || []).map(item => ({
							...item,
							idCompania: this.dialogCompanias,
							nombreCompania: nombreCompania
						})).sort((a, b) => a.secuencia - b.secuencia);
						this.f_calculeTopside();
						this.fgl_consultar = true;
						this.isLoading = false;
						this.isEmpty = this.ajustesTopside.length === 0;
					}).catch((error) => {
						console.error(error);
						this.error = true;
						this.isLoading = false;
						this.$toast.error("Error al consultar ajustes Topside");
					});
				}
				// Si hay grupo seleccionado
				else if (this.grupoId) {
					let companiasAConsultar = [];

					if (this.grupoId === "all") {
						companiasAConsultar = this.companias.map(c => c.id);
					} else {
						const grupoIdStr = this.grupoId.toString();
						companiasAConsultar = this.companias.filter(compania => {
							if (!compania.id_grupos) return false;
							const gruposCompania = compania.id_grupos.split(',').map(id => id.trim());
							return gruposCompania.includes(grupoIdStr);
						}).map(c => c.id);
					}

					if (companiasAConsultar.length === 0) {
						this.$toast.warning("No hay compañías en el grupo seleccionado");
						this.isLoading = false;
						this.isEmpty = true;
						return;
					}

					Balance.getAjustesTopsideMultiples(companiasAConsultar, this.dialogFechas, this.codigoReportePrincipal, v_tipo_ajuste)
						.then(result => {
							this.ajustesTopside = (result.data.ajustesTopside || []).map(item => {
								const compania = this.companias.find(c => c.id == item.idCompania);
								return {
									...item,
									nombreCompania: compania ? compania.nombre : ''
								};
							}).sort((a, b) => a.secuencia - b.secuencia);

							this.f_calculeTopside();
							this.fgl_consultar = true;
							this.isLoading = false;
							this.isEmpty = this.ajustesTopside.length === 0;

							if (companiasAConsultar.length > 0 && this.niif.length === 0) {
								PlanConsolidacion.getPlanConsPorCompVige(this.dialogFechas, this.codigoReportePrincipal)
									.then(niifResult => {
										this.niif = niifResult.data.planConsNiif;
									}).catch(() => { });
							}
						})
						.catch(err => {
							console.error(err);
							this.isLoading = false;
							this.$toast.error("Error al consultar ajustes");
							this.isEmpty = true;
						});
				}
			}
		},
		crear() {
			if (this.isVigenciaBloqueada) {
				this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
				return;
			}
			this.showDialogEdit = true;
			this.v_cuenta = '';
			this.v_descripcion = '';
			this.v_id = null;
			this.v_niif = '';
			this.v_niif1 = null;
			this.v_ajuste_funcional1 = 0;
			this.v_ajuste_promedio1 = 0;
			this.v_ajuste_interna1 = 0;
			this.v_ajuste_funcional2 = 0;
			this.v_ajuste_promedio2 = 0;
			this.v_ajuste_interna2 = 0;
			this.busquedaCuenta = '';
			this.sugerenciasCuentas = [];

			this.f_calculeTopside();

			if (!this.reclasifica) {
				this.v_ajuste_funcional1 = -this.vt_ajuste_funcional1;
				this.v_ajuste_promedio1 = -this.vt_ajuste_promedio1;
				this.v_ajuste_interna1 = -this.vt_ajuste_interna1;
				this.v_ajuste_funcional2 = -this.vt_ajuste_funcional2;
				this.v_ajuste_promedio2 = -this.vt_ajuste_promedio2;
				this.v_ajuste_interna2 = -this.vt_ajuste_interna2;
			}

			const codigoReporte = this.reclasifica ? this.dialogReportes : this.codigoReportePrincipal;

			Balance.getCuentas(this.dialogCompanias, this.dialogFechas, codigoReporte)
				.then((result) => {
					this.cuentas = result.data.cuentas;
				}).catch(() => this.$toast.error("Error al cargar cuentas"));
		},
		f_calculeTopside() {
			this.vt_ajuste_funcional1 = 0; this.vt_ajuste_promedio1 = 0; this.vt_ajuste_interna1 = 0
			this.vt_ajuste_funcional2 = 0; this.vt_ajuste_promedio2 = 0; this.vt_ajuste_interna2 = 0
			if (this.reclasifica) return
			this.ajustesTopside.forEach((cuenta) => {
				if (cuenta.id !== '') {
					this.vt_ajuste_funcional1 += parseFloat(cuenta.ajuste_funcional1 || 0)
					this.vt_ajuste_promedio1 += parseFloat(cuenta.ajuste_promedio1 || 0)
					this.vt_ajuste_interna1 += parseFloat(cuenta.ajuste_interna1 || 0)
					this.vt_ajuste_funcional2 += parseFloat(cuenta.ajuste_funcional2 || 0)
					this.vt_ajuste_promedio2 += parseFloat(cuenta.ajuste_promedio2 || 0)
					this.vt_ajuste_interna2 += parseFloat(cuenta.ajuste_interna2 || 0)
				}
			})
		},
		grabeAjusteTopside() {
			if (this.isVigenciaBloqueada) {
				this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
				return;
			}
			let v_error = false, v_mensaje = '';
			this.formEdit.cuenta = this.v_cuenta;
			this.formEdit.descripcion = this.v_descripcion;
			this.formEdit.ajuste_funcional1 = this.v_ajuste_funcional1;
			this.formEdit.ajuste_promedio1 = this.v_ajuste_promedio1;
			this.formEdit.ajuste_interna1 = this.v_ajuste_interna1;
			this.formEdit.ajuste_funcional2 = this.v_ajuste_funcional2;
			this.formEdit.ajuste_promedio2 = this.v_ajuste_promedio2;
			this.formEdit.ajuste_interna2 = this.v_ajuste_interna2;
			this.formEdit.codReporte = this.reclasifica ? this.dialogReportes : this.codigoReportePrincipal;
			this.formEdit.niif = this.v_niif;
			this.formEdit.tipo_ajuste = this.reclasifica ? 1 : 0;

			if (this.formEdit.cuenta == '') {
				this.$toast.error("Falta Cuenta");
				return;
			}

			if (this.reclasifica) {
				this.formEdit.niif1 = this.v_niif1;
				if (!this.formEdit.niif1) {
					v_mensaje = "Falta Niif(Reclasificado)";
					v_error = true;
				} else if (this.formEdit.niif == this.formEdit.niif1) {
					v_mensaje = "Niif y Niif(Reclasificado) deben ser diferentes";
					v_error = true;
				}
			}

			if (v_error) {
				this.$toast.error(v_mensaje);
				return;
			}

			this.showDialogEdit = false;
			this.formEdit.u_crea = this.$store.state.userId;

			Balance.grabeAjusteTopside(this.dialogCompanias, this.dialogFechas, this.formEdit)
				.then((result) => {
					if (result.status == 200) {
						this.$toast.success("Informacion Grabada");
						this.consultar();
					} else {
						this.$toast.error("Problema al grabar");
					}
				})
				.catch(() => this.error = true);
		},

		borraAjusteTopside(secuencia) {
			if (this.isVigenciaBloqueada) {
				this.$toast.error("La vigencia seleccionada está deshabilitada para eliminar");
				return;
			}
			this.showDialogTopside = false
			const v_tipo_ajuste = this.$route.name == "ajustesTopside" ? 0 : 1
			Balance.borraAjusteTopside(this.dialogCompanias, this.dialogFechas, secuencia, v_tipo_ajuste)
				.then((result) => {
					if (result.status == 200) {
						this.$toast.success("Informacion Borrada")
						this.consultar()
					} else {
						this.$toast.error("Problema al Borrar")
					}
				})
				.catch(() => this.error = true)
		},
		f_titulo() {
			const titulos = {
				ajustesTopside: { es: "AJUSTES TOPSIDE", en: "TOPSIDE ADJUSTMENT" },
				reclasificaBalance: { es: "RECLASIFICACION SALDOS DE BALANCES", en: "BALANCE RECLASSIFICATION" }
			}
			const ruta = this.$route.name
			return this.$store.state._language == "es-ES" ? titulos[ruta].es : titulos[ruta].en
		},
		f_niifCuenta(cuenta) {
			const niif = this.mapaNiifCuenta[cuenta]
			return this.mapaNiif[niif] || ""
		},
		f_niifCuenta1(cuenta) {
			let a_niif = this.niifCuentas.filter((item) => item.cuenta == cuenta)
			if (a_niif.length > 0) {
				return a_niif[0].niif
			}
			return ""
		},
		f_niif(niif) {
			let a_descripcion = this.niif.filter((item) => item.niif == niif)
			if (a_descripcion.length > 0) {
				return a_descripcion[0].nameNiif
			}
			return ""
		},
		formato(numero) {
			return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero)
		},
		formatoNumero(numero) {
			if (numero === null || numero === undefined) return "0.00"
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(numero)
		},
		f_muestra(r_topside) {
			if (r_topside.id === '') return
			this.selectedRow = r_topside.secuencia
			this.showDialogTopside = true
			this.formTopside = r_topside
			this.formTopside.niif_desc = this.f_niif(r_topside.niif)
			this.formTopside.niif1_desc = this.f_niif(r_topside.niif1)
		}
	},
	watch: {
		dialogFechas() {
			if (this.isVigenciaBloqueada) {
				this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
			}
		}
	},
	mounted() {
		this.isLoading = true;
		this.reclasifica = this.$route.name == "reclasificaBalance";

		const promises = [
			Grupo.getAllGrupos(),
			Balance.leaCompaniaUsuario(),
			Balance.getCompanias(true),
			Balance.getFechas()
		];

		if (this.reclasifica) {
			promises.push(Balance.getReportes());
		} else {

			promises.push(AjustesConsol.getReportePrincipal());
		}

		Promise.all(promises)
			.then(([gruposResult, companiaResult, companiasResult, fechasResult, extraResult]) => {
				this.listGrupos = gruposResult.data.grupos;
				this.companiaUsuario = companiaResult.data.companiaUsuario;
				this.companias = companiasResult.data.companias.filter(element => {
					const v_usuario = this.companiaUsuario.find(r_usuario =>
						r_usuario.id_usuario == this.$store.state.userId && r_usuario.id_compania == element.id);
					return this.$store.state.userRole == 1 || v_usuario;
				});
				this.companiasFiltradas = [...this.companias];
				this.fechas = ordenefechas(fechasResult.data.fechas);

				if (this.reclasifica) {
					this.reportes = extraResult.data.reportes;
				} else {
					if (!extraResult.data.codigo) {
						throw new Error('No se encontró reporte principal');
					}
					this.codigoReportePrincipal = extraResult.data.codigo;
				}

				this.isLoading = false;
			})
			.catch((error) => {
				console.error('Error en mounted:', error);
				this.error = true;
				this.isLoading = false;
				this.$toast.error("Error al cargar los datos iniciales");
			});
	}
}
</script>

<style scoped>
.balance-table>>>.md-table-cell {
	padding: 6px 4px !important;
}

.clickable-row {
	cursor: pointer;
	transition: background-color 0.2s;
}

.clickable-row:hover {
	background-color: #f5f5f5 !important;
}

.selected-row {
	background-color: #e8f4fd !important;
	border-left: 3px solid #2c5f7a !important;
}

.border {
	border: 1px solid #dee2e6 !important;
}

.number-cell {
	text-align: right !important;
	font-family: 'Courier New', monospace !important;
}

.descripcion-cell {
	text-align: left !important;
	max-width: 300px !important;
}

/* ESTILOS PARA LOS FILTROS */
.form-control-lg.w-auto {
	min-width: 220px !important;
	width: auto !important;
	display: inline-block !important;
	font-size: 1.5rem !important; 
}

.filtro-select {
	min-width: 220px !important;
	max-width: 220px !important;
	width: 220px !important;
	white-space: nowrap !important;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	font-size: 1.25rem !important; /* fs-5 */
}

.cursor-pointer {
	cursor: pointer;
}

.hover-bg:hover {
	background-color: #f0f0f0 !important;
}

/* MEDIA QUERY PARA DISPOSITIVOS MÓVILES */
@media (max-width: 768px) {
	.balance-table>>>.md-table-cell {
		padding: 4px 2px !important;
		font-size: 12px !important;
	}
	
	.form-control-lg,
	.form-select-lg,
	.form-control-lg.w-auto,
	.filtro-select {
		font-size: 1rem !important;
		padding: 0.375rem 0.75rem !important;
		min-width: 180px !important;
	}
	
	.btn-lg {
		padding: 0.375rem 0.75rem !important;
		font-size: 1rem !important;
	}
	
	.fw-bold.fs-4 {
		font-size: 1.25rem !important;
	}
}


</style>
